<template>
    <div class="card mb-0">
        <div class="card-header d-flex">
            <h3>Personal</h3><span class="f-14 pull-right mt-0">{{ menu.length }} Contacts</span>
        </div>
        <div class="card-body p-0">
            <div class="row list-persons" id="addcon">
                <div class="col-xl-4 xl-50 col-md-5 box-col-6">
                    <div class="nav flex-column nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                        <a class="contact-tab-0 nav-link" :class="item.active?'active show':''" id="v-pills-user-tab" data-bs-toggle="pill"
                            @click="activeDiv(item.id)" :href="'#v-pills-user' + item.id" role="tab"
                            aria-controls="v-pills-user" aria-selected="true" v-for="(item, index) in menu" :key="index">
                            <div class="d-flex"><img class="img-50 img-fluid m-r-20 rounded-circle update_img_0"
                                    :src="item.imgUrl || getImgUrl(item.img)" alt="">
                                <div class="flex-grow-1">
                                    <h6> <span class="first_name_0">{{ item.name }} </span><span class="last_name_0">{{
                                        item.lastName }}</span></h6>
                                    <p class="email_add_0">{{ item.email }}</p>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
                <div class="col-xl-8 xl-50 col-md-7 box-col-6">
                    <div class="tab-content" id="v-pills-tabContent" :style="!this.display ? { display: 'none' } : ''">
                        <div class="tab-pane contact-tab-0 tab-content-child fade show"
                            :class="[item.active ? 'active show' : '']" :id="'v-pills-user' + item.id" role="tabpanel"
                            aria-labelledby="v-pills-user-tab" v-for="(item, index) in menu" :key="index" @click="changeDetails(item)">
                            <div class="profile-mail">
                                <div class="d-flex align-items-center">
                                    <img class="img-100 img-fluid m-r-20 rounded-circle update_img_0"
                                        :src="item.imgUrl || getImgUrl(item.img)" alt="">
                                    <input class="updateimg" type="file" name="img" @change="(e) => { readURL(e, item) }">
                                    <div class="flex-grow-1 mt-0">
                                        <h3><span class="first_name_0">{{ item.name }} </span><span class="last_name_0">{{
                                            item.lastName }}</span></h3>
                                        <p class="email_add_0">{{ item.email }}</p>
                                        <ul>
                                            <li><a href="javascript:void(0)" @click="editContact()">Edit</a> </li>
                                            <li><a href="javascript:void(0)" @click="deleteContact(item,index)">Delete</a></li>
                                            <historyPage />
                                            <li><a href="javascript:void(0)"
                                                    @click="() => { this.$store.dispatch('contact/setSelectedContact', item) }"
                                                    data-bs-toggle="modal" data-bs-target="#printModal">Print</a></li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="email-general">
                                    <h4 class="mb-3">General</h4>
                                    <ul>
                                        <li>Name <span class="font-primary first_name_0">{{ item.name }}</span></li>
                                        <li>Gender <span class="font-primary">{{ item.gender }}</span></li>
                                        <li>Birthday<span class="font-primary"> <span class="birth_day_0">18</span><span
                                                    class="birth_month_0 ms-1">May</span><span
                                                    class="birth_year_0 ms-1">1994</span></span></li>
                                        <li>Personality<span class="font-primary personality_0">Cool</span></li>
                                        <li>City<span class="font-primary city_0">moline acres</span></li>
                                        <li>Mobile No<span class="font-primary mobile_num_0">{{ item.mobile }}</span></li>
                                        <li>Email Address <span class="font-primary email_add_0">barnes@gmail.com </span>
                                        </li>
                                        <li>Website<span class="font-primary url_add_0">www.test.com</span></li>
                                        <li>Interest<span class="font-primary interest_0">photography</span></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <editPage />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import contectMixin from "@/mixins/contectMixin"

import historyPage from './historyPage.vue'
import editPage from './editPage.vue'

export default {
    mixins: [contectMixin],
    components: {
        historyPage, editPage
    },
}
</script>
